import { Immutable } from 'immer'
import { IKvitteringData } from '../../ducks/kvittering/types'
import { ITilsynsobjekt } from './types'

export { getTilsynsobjekterFromKvittering }

const getTilsynsobjekterFromKvittering = (
  kvittering: Immutable<IKvitteringData>
) => [...kvittering.tilsynsobjekter] as ITilsynsobjekt[]
